<template>
  <transition-group name="fade-arquivos">
    <ArquivoBase
      v-for="arquivo in listaArquivos"
      :key="arquivo.objetoArquivo.id"
      :tipoArquivo="arquivo.tipoArquivo"
      :objetoArquivo="arquivo.objetoArquivo"
      :barraProgresso="arquivo.barraProgresso"
      @baixar-arquivo="uuid => $emit('baixar-arquivo', uuid)"
    />
  </transition-group>
</template>

<script>
import ArquivoBase from "./TiposArquivos/ArquivoBase";

export default {
  components: {
    ArquivoBase
  },
  props: {
    listaArquivos: {
      type: Array,
      default: () => [
        // {
        //   tipoArquivo: "",
        //   objetoArquivo: {
        //     nomeArquivo: "",
        //     tamanhoArquivo: 0,
        //     dataEnvio: "",
        //     dataAlteracao: "",
        //     dataAlteracao: "",
        //     barraProgresso: 0
        //   },
        //   barraProgresso: 0
        // }
      ]
    }
  }
};
</script>

<style lang="scss" scoped></style>
